import RandingStyle22 from "../../randing/RandingStyle22";

function Randing290({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <RandingStyle22
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/290/01.jpg`}
        formFieldColor="white"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/green/applyButton_small.png`}
        companyName="본원"
        fixedDbColor="rgba(255, 255, 255, 0.8)"
        articleOption={true}
        benefitInfo={false}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing290;
